import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearUserEmail } from '../redux/auth';

export type UserRole = 'client' | 'admin';

type User = {
  id: number;
  email: string;
  token: string;
  role: UserRole;
};

interface AuthContextType {
  isLoggedIn: boolean;
  user: User | null;
  /** True only for a signed-in user the API reported as an admin. */
  isAdmin: boolean;
  login: (user: User) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const login = (userData: User) => {
    localStorage.setItem('accessToken', userData.token); // make sure `token` exists in User type
    localStorage.setItem('user', JSON.stringify(userData));
    setIsLoggedIn(true);
    setUser(userData);
  };

  // useEffect(() => {
  //   const accessToken = localStorage.getItem('accessToken');

  //   if (accessToken) {
  //     try {
  //       // setUser(parsedUser);
  //       setIsLoggedIn(true);
  //     } catch (err) {
  //       console.error('Failed to parse user from localStorage:', err);
  //       localStorage.removeItem('user');
  //     }
  //   }
  // }, []);

  useEffect(() => {
    setLoading(false);
    const token = localStorage.getItem('accessToken');
    const storedUser = localStorage.getItem('user');
    if (token && storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser({ ...parsedUser, token });
        setIsLoggedIn(true);
      } catch (err) {
        console.error('Failed to parse user from localStorage:', err);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const logout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('accessToken'); 
    localStorage.removeItem('user');
    dispatch(clearUserEmail())
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ isLoggedIn, user, isAdmin: user?.role === 'admin', login, logout }}
    >
      {/* {children} */}
      {!loading && children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};